import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';

import {
  button as defaultStyle,
  primary as primaryStyle,
  small as smallStyle,
  secondary as secondaryStyle,
} from '../Button/styles.module.css';

const ToPropType = PropTypes.shape({
  pathname: PropTypes.string,
  hash: PropTypes.string,
});

/**
 * Button link presentational component.
 * Styles a link to look like a button.
 * */
const ButtonLink = ({
  children,
  className,
  disabled,
  href,
  primary,
  secondary,
  to,
  small,
  ...props
}) => {
  const Component = to ? Link : 'a';
  return (
    <Component
      className={classnames({
        [primaryStyle]: !!primary,
        [secondaryStyle]: !!secondary,
        [smallStyle]: !!small,
        [defaultStyle]: !primary && !secondary,
        [className]: !!className,
      })}
      {...(to && !disabled && { to })}
      {...(href && !disabled && { href })}
      disabled={disabled}
      {...props}
    >
      {children}
    </Component>
  );
};

ButtonLink.propTypes = {
  /**
   * Children contents of button.
   */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Boolean to disabled button.
   */
  disabled: PropTypes.bool,
  /**
   * String href attribute for external link destinations.
   */
  href: PropTypes.string,
  /**
   * Boolean to style button as primary.
   */
  primary: PropTypes.bool,
  small: PropTypes.bool,
  /**
   * String to attribute for internal router destinations.
   */
  to: PropTypes.oneOfType([PropTypes.string, ToPropType]),
};

ButtonLink.defaultProps = {
  className: undefined,
  disabled: false,
  href: undefined,
  primary: false,
  to: undefined,
  small: undefined,
};

export default ButtonLink;

export { ToPropType };
